import React, { FC } from 'react';
import { Close } from '@material-ui/icons';
import { DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { useStyles } from './styles';

interface DialogTitleProps {
  title?: string;
  onClose: () => void;
}

export const CustomDialogTitle: FC<DialogTitleProps> = ({ title, onClose }) => {
  const classes = useStyles();

  return (
    <DialogTitle disableTypography className={classes.dialogTitle}>
      <Grid container justify="space-between" spacing={1} alignItems="center">
        <Typography className={classes.title}>{title}</Typography>
        <IconButton className={classes.closeBtn} onClick={() => onClose()}>
          <Close />
        </IconButton>
      </Grid>
    </DialogTitle>
  );
};
